import { resolveComponent as _resolveComponent, createVNode as _createVNode, withMemo as _withMemo } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_descriptor = _resolveComponent("inline-descriptor")!

  return _withMemo([_ctx.computedModelValue, _ctx.computedSchema], () => _createVNode(_component_inline_descriptor, {
    ref: "inlineDescriptorDisplay",
    id: _ctx.id,
    "model-value": _ctx.computedModelValue,
    schema: _ctx.computedSchema,
    "token-styles": _ctx.tokenStyles,
    separators: _ctx.separators,
    "is-table": _ctx.isTable,
    editable: false
  }, null, 8, ["id", "model-value", "schema", "token-styles", "separators", "is-table"]), _cache, 0)
}